import {DbType, DisplayType, FilterType} from "@/enum/filters";

export class Attribute {
  value?: string | Record<string, Attribute>;
  label?: string;
  labelText?: string;
  unit?: string | null;
  displayType?: DisplayType | null;
  filterType?: FilterType | null;
  index?: number;
  dbType?:DbType | null

  [x: string]: unknown;

  public static of(data: any): Attribute {
    const a: Attribute = new Attribute();
    let value:string | null=null;
    let unit:string | null=null
    try {
      if (data.dbType === "MEASURE") {
        value = data.value[0].value
        unit = data.value[0].unit
      }
    }
    catch(e) { /*nothing*/ }

    a.value = value ? [value] : typeof data.value==='string'?[data.value]:data.value;
    a.label = data.label;
    a.labelText = data.label;
    a.unit = unit? unit : null;
    a.displayType = data.displayType;
    a.dbType = data.dbType;
    a.filterType = data.filterType;
    a.index = data.index;

    return a;
  }
}

export class FilterableAttribute {
  availableValues?: Array<string | any>;
  label?: string;
  unit?: string | null;
  filterType?: FilterType | null;
  index?: number;
  dbType?:DbType | null
  filterName?: string;
  step?: number;

  selectedValues: Array<string | any> | null = [];
  opened= false;
  disabled = false;
  hidden = false;

  get min(): number {
    return this.availableValues?.[0];
  }

  get max(): number {
    return this.availableValues?.[1];
  }

  get selectedMin(): number {
    return this.selectedValues?.[0];
  }

  get selectedMax(): number {
    return this.selectedValues?.[1];
  }

  public static of(data: any): FilterableAttribute {
    const f: FilterableAttribute = new FilterableAttribute();

    f.label = data.label;
    f.unit = data.unit;
    f.dbType = data.dbType;
    f.filterType = data.filterType;
    f.index = data.index;
    f.filterName = data.name
    f.availableValues = data.values || [];
    f.step = data.step && parseFloat(data.step) || 1
    f.hidden = data.hidden;

    return f;
  }
  
}